export default {
  components: {},
  data() {
    return {
      loading: false,
      isPopstate: false,
      transitionName: 'fade'
      // path: '',
    };
  },

  computed: {
    fullPath() {
      return this.$route.fullPath;
    },
    path() {
      return this.$route.path;
    },
    keepAlive() {
      return (this.$route.meta || {}).keepAlive;
    },
    stateAudio() {
      const {
        audio
      } = this.$store.state;
      return audio;
    },
    visibleAudio() {
      const {
        visibleAudio
      } = this.$route.meta;
      return visibleAudio;
    }
  },
  methods: {
    handlePlay() {
      if (this.$audio.paused) {
        this.$audio.play();
      } else {
        this.$audio.pause();
      }
    }
  },
  created() {},
  mounted() {
    // 解决ios不支持按钮:active伪类的方法
    document.body.addEventListener('touchstart', () => {});
    // 解决ios输入表单被键盘顶上后无法恢复的问题
    if (this.isApple) {
      let oldScrollTop = 0;
      let isFocus = false; // 防止输入框之前切换时界面上下滚动
      // const handleFocus = (e) => {
      //   isFocus = true;
      //   // e.target.scrollIntoView({ behavior: 'smooth' });
      //   setTimeout(() => {
      //     // console.log('focus');
      //     oldScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      //     isFocus = false;
      //     // ios 16系统键盘顶不上去
      //     function isiOS16() {
      //       var ua = navigator.userAgent;
      //       var iosVersionStr = /OS (\d+)_(\d+)_?(\d+)?/.exec(ua);
      //       var version = iosVersionStr ? parseInt(iosVersionStr[1], 10) : null;
      //       return version === 16;
      //     }
      //     console.log(e.target.scrollTop);
      //     if (['INPUT', 'TEXTAREA'].some((val) => val === e.target.tagName) && oldScrollTop === 0 && isiOS16() && this.isApp) {
      //       document.documentElement.scrollTop = document.body.scrollHeight * 0.6;
      //     }
      //   }, 100);
      // };
      const handleBlur = () => {
        setTimeout(() => {
          if (isFocus) return;
          if (window.scrollTo) {
            // console.log('blur');
            window.scrollTo(0, oldScrollTop);
          }
        }, 50);
      };
      // document.addEventListener('focus', handleFocus, true);
      document.addEventListener('blur', handleBlur, true);

      // 监听整个文档的点击事件
      document.addEventListener('click', function (event) {
        // 检查事件是否发生在特定的元素之外
        if (event.target === document.body) {
          // 关闭键盘
          var inputElements = document.querySelectorAll('input, textarea');
          for (var i = 0; i < inputElements.length; i++) {
            inputElements[i].blur(); // 使输入框失去焦点，触发键盘隐藏
          }
        }
      });
    }

    // 地址栏回退(前进也执行，无法判断)
    window.addEventListener('popstate', () => {
      this.isPopstate = true;
    });
    // this.$nextTick(() => {
    //   if (window.scrollTo) {
    //     const scrollTop = document.documentElement.scrollTop + 5;
    //     window.scrollTo(0, document.documentElement.scrollHeight);
    //     window.scrollTo(0, scrollTop);
    //   }
    // });
  },

  watch: {
    $route: {
      deep: true,
      handler(newValue) {
        // if (this.path !== newValue.path && newValue.path !== '/') {
        //   this.path = newValue.path;
        //   console.log(this.path, newValue.path);
        // }
        // 路由切换效果(刷新浏览器是不使用)
        if (this.loading) {
          this.transitionName = this.isPopstate ? 'slide-router-right' : 'slide-router-left';
        }
        this.loading = true;
        this.isPopstate = false;

        // 滚动条自动滚动5px，然后回位(避免ios回退偶现白屏)
        const meta = newValue.meta || {};
        this.$nextTick(() => {
          if (window.scrollTo) {
            const scrollTop = document.documentElement.scrollTop + 5;
            window.scrollTo(0, document.documentElement.scrollHeight);
            window.scrollTo(0, scrollTop);
          }
        });

        // 自动播放音乐
        if (!meta.visibleAudio) {
          this.$audio.pause();
        } else {
          this.$audio.src = this.stateAudio.src;
          this.$audio.loop = true;
          this.$audio.play();
        }
      }
    }
  }
};